import type { GetWinnerRow } from '@morfi/backend-sdk-v2/client';
import { marketPoolQuoteSnapshotFromRow } from '@morfi/market-math';

import type { OnchainTradeData } from './onchain-trade-data-projection';

/** Projects the narrow indexed winner response into the shared exact quote contract. */
export function winnerTradeDataFromRow(winner: GetWinnerRow): OnchainTradeData {
  const pool = winner.currentPoolState;
  return marketPoolQuoteSnapshotFromRow(
    {
      pubkey: winner.parentMarket.pubkey,
      status: 'graduated',
      marketStateSequence: null,
      winnerOutcomeIndex: winner.outcomeIndex,
      outcomes: [
        {
          outcomeIndex: winner.outcomeIndex,
          mint: winner.mint,
          graduated: true,
          currentPoolState: {
            quoteVaultReserveD6: pool.quoteVaultReserveD6,
            outcomeVaultReserveD6: pool.outcomeVaultReserveD6,
            tradeFeeRateMillionths: pool.tradeFeeRateMillionths,
            creatorFeeRateMillionths: pool.creatorFeeRateMillionths,
            creatorFeeEnabled: pool.creatorFeeEnabled,
            creatorFeeOn: pool.creatorFeeOn,
            outcomeTokenIndex: pool.outcomeTokenIndex,
            swapEnabled: true,
            openTimeUnixSeconds: String(pool.openTimeUnixSeconds),
            observedAtUnixSeconds: String(pool.observedAtUnixSeconds),
          },
        },
      ],
    },
    {},
  );
}
